require('../../../corporate-template/js/feature/intro-banner.js');